import { PageIntro } from "@/components/kit/PageIntro";
import { JourneySteps } from "@/components/blocks/JourneySteps";
import { CtaBand } from "@/components/kit/CtaBand";
import { MaskLines, Reveal } from "@/components/site/Motion";
import { usePageMeta } from "@/components/site/Seo";

const EXPECT = [
  { t: "We listen", d: "Your routine, your food, your family, your schedule and what has got in the way before." },
  { t: "We get clear", d: "A realistic goal and pace. No crash promises, just ranges you can trust." },
  { t: "You decide", d: "If the programme fits, we'll explain the next step. If not, you leave with useful advice anyway." },
];

export default function HowItWorks() {
  usePageMeta("How It Works", "A simple, supportive 4-step journey: free consultation, personalised plan, ongoing coaching and sustainable results.");
  return (
    <div data-testid="how-it-works-page">
      <PageIntro testId="how-hero" eyebrow="How it works" lines={["From one call", <em key="t" className="text-gold-soft">to a new normal.</em>]} intro="Simple, personal and paced for real life. Here is exactly what happens from your first conversation to day 120 and beyond." />
      <JourneySteps showLink={false} showExtras />
      <section data-testid="consultation-expect" className="bg-beige py-24 sm:py-32">
        <div className="wrap">
          <p className="eyebrow">The free consultation</p>
          <h2 className="mt-5 max-w-3xl text-5xl leading-[0.98] text-forest sm:text-6xl"><MaskLines lines={["Twenty minutes.", <em key="z" className="text-pine">Zero pressure.</em>]} /></h2>
          <div className="mt-14 grid gap-10 md:grid-cols-3">
            {EXPECT.map((e, i) => (
              <Reveal key={e.t} delay={i * 0.1}>
                <div className="border-t border-forest/20 pt-6">
                  <span className="font-display text-xl italic text-gold-ink">0{i + 1}</span>
                  <h3 className="mt-3 font-display text-4xl text-forest">{e.t}</h3>
                  <p className="mt-3 text-base leading-relaxed text-charcoal-soft">{e.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <CtaBand testId="how-cta" />
    </div>
  );
}
